if ($("#mapdiv-usa-design-center").length > 0) {
    var map = (function () {
      /* http://docs.amcharts.com/3/javascriptmaps/AmMap */
      var map;
      var targetSVG = "M9,15.93 c-3.83,0-6.93-3.1-6.93-6.93S5.17,2.07,9,2.07s6.93,3.1,6.93,6.93S12.83,15.93,9,15.93";
      AmCharts.ready(function () {
        // * Set up our locations
        var mapLocations = [{
          balloonText: 'Phoenix, AZ',
          url: '/state/az/phoenix/design-center',
          latitude: 34.1264,
          longitude: -112.0478
        },
        {
            balloonText: "Tucson, AZ",
          url: '/state/az/tucson/design-center',
          latitude: 32.2217,
          longitude: -110.9265
        },
        {
          balloonText: "Northern California",
          url: '/state/ca/bay-area/design-center',
          latitude: 37.7749,
          longitude: -122.4194
        },
        {
          balloonText: "Southern CA",
          url: '/state/ca/southern-ca/design-center',
          latitude: 34.0522,
          longitude: -118.2437
        },
        {
          balloonText: "Denver, CO",
          url: '/state/co/denver/design-center',
          latitude: 39.742043,
          longitude: -104.991531
        },
        {
          balloonText: "Orlando, FL",
          url: '/state/fl/orlando/design-center',
          latitude: 28.5383,
          longitude: -81.3792
        },
        {
          balloonText: "Tampa/Sarasota, FL",
          url: '/state/fl/tampa/design-center',
          latitude: 27.9506,
          longitude: -82.4572
        },
        {
          balloonText: "Atlanta, GA",
          url: '/state/ga/atlanta/design-center',
          latitude: 33.7489,
          longitude: -84.3879
        },
        {
          balloonText: "Charlotte Metro, NC",
          url: '/state/nc/charlotte/design-center',
          latitude: 35.6866,
          longitude: -80.8981
        },
        {
          balloonText: "Raleigh, NC",
          url: '/state/nc/raleigh/design-center',
          latitude: 35.7795,
          longitude: -78.6381
        },
        {
          balloonText: "Greenville, SC",
          url: '/state/sc/greenville/design-center',
          latitude: 34.8526,
          longitude: -82.3940
        },
        {
          balloonText: "York County, SC",
          url: '/state/nc/charlotte/design-center',
          latitude: 34.2695,
          longitude: -80.8407
        },
        {
          balloonText: "Nashville, TN",
          url: '/state/tn/nashville/design-center',
          latitude: 36.1626,
          longitude: -86.7816
        },
        {
          balloonText: "Austin, TX",
          url: '/state/tx/austin/design-center',
          latitude: 30.2671,
          longitude: -97.7430
        },
        {
          balloonText: "Dallas/Ft. Worth, TX",
          url: '/state/tx/dallasft-worth/design-center',
          latitude: 32.7766,
          longitude: -96.7969
        },
        {
          balloonText: "Houston, TX",
          url: '/state/tx/houston/design-center',
          latitude: 29.7604,
          longitude: -95.3698
        },
        {
          balloonText: "San Antonio, TX",
          url: '/state/tx/san-antonio/design-center',
          latitude: 28.5992,
          longitude: -98.96
        }
        ];
        // * Complete our location objects with standard values
        var locations = _.forEach(mapLocations, function (item, i) {
          return _.merge(item, {
            svgPath: targetSVG,
            color: '#fefefe',
            rollOverScale: 2,
            tabIndex: i
          });
        });
        // * Build the Map
        map = new AmCharts.AmMap();
        map.areasSettings = {
          autoZoom: false,
          outlineColor: '#ffffff',
          rollOverColor: '#bbdc96',
          rollOverOutlineColor: '#ffffff',
        };
        map.addClassNames = true;
        map.dragMap = false;
        map.zoomControl = {
          homeButtonEnabled: false,
          zoomControlEnabled: false
        };
        map.mouseWheelZoomEnabled = false;
        map.zoomOnDoubleClick = false;
        map.dataProvider = {
          mapVar: AmCharts.maps.usa2Low,
          getAreasFromMap: false,
          areas: [{
            id: "US-AL",
            color: "#d9e5ef",
            rollOverColor: "#d9e5ef"
          },
          {
            id: "US-AR",
            color: "#a7c3d9",
            rollOverColor: "#a7c3d9"
          },
          {
            id: "US-AZ",
            color: "#1c659c",
            rollOverColor: "#bbdc96"
          },
          {
            id: "US-CA",
            color: "#1c659c",
            rollOverColor: "#bbdc96"
          },
          {
            id: "US-CO",
            color: "#1c659c",
            rollOverColor: "#bbdc96"
          },
          {
            id: "US-CT",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-DC",
            color: "#a7c3d9",
            rollOverColor: "#a7c3d9"
          },
          {
            id: "US-DE",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-FL",
            color: "#1c659c",
            rollOverColor: "#bbdc96"
          },
          {
            id: "US-GA",
            color: "#1c659c",
            rollOverColor: "#bbdc96"
          },
          {
            id: "US-IA",
            color: "#d9e5ef",
            rollOverColor: "#d9e5ef"
          },
          {
            id: "US-ID",
            color: "#d9e5ef",
            rollOverColor: "#d9e5ef"
          },
          {
            id: "US-IL",
            color: "#a7c3d9",
            rollOverColor: "#a7c3d9"
          },
          {
            id: "US-IN",
            color: "#a7c3d9",
            rollOverColor: "#a7c3d9"
          },
          {
            id: "US-KS",
            color: "#a7c3d9",
            rollOverColor: "#a7c3d9"
          },
          {
            id: "US-KY",
            color: "#a7c3d9",
            rollOverColor: "#a7c3d9"
          },
          {
            id: "US-LA",
            color: "#a7c3d9",
            rollOverColor: "#a7c3d9"
          },
          {
            id: "US-MA",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-MD",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-ME",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-MI",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-MN",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-MO",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-MS",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-MT",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-NC",
            color: "#1c659c",
            rollOverColor: "#bbdc96"
          },
          {
            id: "US-ND",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-NE",
            color: "#a7c3d9",
            rollOverColor: "#a7c3d9"
          },
          {
            id: "US-NH",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-NJ",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-NM",
            color: "#a7c3d9",
            rollOverColor: "#a7c3d9"
          },
          {
            id: "US-NV",
            color: "#a7c3d9",
            rollOverColor: "#a7c3d9"
          },
          {
            id: "US-NY",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-OH",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-OK",
            color: "#d9e5ef",
            rollOverColor: "#d9e5ef"
          },
          {
            id: "US-OR",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-PA",
            color: "#a7c3d9",
            rollOverColor: "#a7c3d9"
          },
          {
            id: "US-RI",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-SC",
            color: "#1c659c",
            rollOverColor: "#bbdc96"
          },
          {
            id: "US-SD",
            color: "#d9e5ef",
            rollOverColor: "#d9e5ef"
          },
          {
            id: "US-TN",
            color: "#1c659c",
            rollOverColor: "#bbdc96"
          },
          {
            id: "US-TX",
            color: "#1c659c",
            rollOverColor: "#bbdc96"
          },
          {
            id: "US-UT",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-VA",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-VT",
            color: "#ccdde9",
            rollOverColor: "#ccdde9"
          },
          {
            id: "US-WA",
            color: "#a7c3d9",
            rollOverColor: "#a7c3d9"
          },
          {
            id: "US-WI",
            color: "#a7c3d9",
            rollOverColor: "#a7c3d9"
          },
          {
            id: "US-WV",
            color: "#a7c3d9",
            rollOverColor: "#a7c3d9"
          },
          {
            id: "US-WY",
            color: "#a7c3d9",
            rollOverColor: "#a7c3d9"
          }
          ],
          images: locations
        };
        map.write('mapdiv-usa-design-center');
      });
  
      $(window).resize(function () {
        $('.amcharts-chart-div').css('width', $(window).width() - 30);
      });
  
      $(window).on('orientationchange', function () {
        $('.amcharts-chart-div').css('width', $(window).width() - 30);
      });
    })();
}